import { useMutation, useQueryClient, type MutationMeta } from '@tanstack/react-query';
import type { UpdateChannelBody } from '../../apis/comms.js';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import type { ChannelSummary } from '../../interfaces/ICommsApi.js';
import { commsKeys } from '../queryKeys.js';

/** `meta`: the mutation's react-query meta — `OWNS_ERROR_FEEDBACK` when the caller reports a failure itself. */
export function useEditChannel(siteId: string, meta?: MutationMeta) {
  const { updateChannel } = useClientApis().comms;
  const queryClient = useQueryClient();

  return useMutation({
    meta,
    mutationFn: ({ channelId, body }: { channelId: string; body: UpdateChannelBody }) =>
      updateChannel(siteId, channelId, body),
    onSuccess: (response) => {
      // Patch the channel list cache in place so the sidebar reflects the
      // new name / member count instantly without a full refetch.
      queryClient.setQueryData<{ channels: ChannelSummary[] }>(
        commsKeys.channels(siteId),
        (cached) => {
          if (!cached) return cached;
          return {
            channels: cached.channels.map((ch) =>
              ch.id === response.channel.id ? response.channel : ch,
            ),
          };
        },
      );
    },
  });
}
